import React, { useState, useEffect, useRef } from "react";
import { LazyLoadImage } from 'react-lazy-load-image-component';

function useInterval(callback, delay) {
  const savedCallback = useRef();

  // Remember the latest function.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

const Image = (props) => {

    const [charURL, setChartURL] = useState(props.chartUrl);
    
    useInterval(() => {
      setChartURL(`${props.chartUrl}?${new Date()}`);
    }, 60000);

    useEffect(() => {
      setChartURL(props.chartUrl);
    }, [props.chartUrl])

    const baseUrl = 'https://goldprice.org/charts/';
    const hostname = window.location.hostname;
    let redirect_link = '#'
    console.log(props.title);
    if(props.title.includes('silver')) {
      redirect_link = '/silver-price.html'
    }
    else{
      redirect_link = '/spot-gold.html'
    }        
    
    return (
        <div>
          <a href={redirect_link}>
            <LazyLoadImage loading="lazy" src={`${baseUrl}${charURL}`} alt={props.title} />
          </a>
        </div>
    )
}

export default Image; 
